import styled from 'styled-components';
import { useTranslations } from 'ilenia';

import {
  getBackgroundColor,
  contrastingTextColor,
} from '@bscom/styling/mixins';
import { Spacing } from '@bscom/components/Spacing';
import { zIndexes } from '@bscom/constants/zIndexes';
import { SPACING_MOBILE } from '@bscom/constants/heights';
import { DESKTOP_LARGE_WIDTH } from '@bscom/constants/widths';

export const NoJSBanner = styled.div`
  text-align: center;
  overflow: hidden;
  width: 100%;
  z-index: ${zIndexes.NOTIFICATIONS};
  background-color: ${getBackgroundColor('green')};
  color: ${contrastingTextColor('green')};

  a {
    color: ${contrastingTextColor('green')};
    font-weight: bold;
    text-decoration: underline;
  }
`;

export const NoJSBannerContent = styled.div`
  display: flex;
  align-items: center;
`;

export const NoJSText = styled.div`
  flex-grow: 1;
`;

export const NoJSNotification = () => {
  const [translations] = useTranslations();

  return (
    <NoJSBanner>
      <Spacing
        spaces={{ top: SPACING_MOBILE, bottom: SPACING_MOBILE }}
        contentWidth={DESKTOP_LARGE_WIDTH}
      >
        <NoJSBannerContent>
          <NoJSText
            dangerouslySetInnerHTML={{
              __html: translations['notifications/nojs'],
            }}
          />
        </NoJSBannerContent>
      </Spacing>
    </NoJSBanner>
  );
};
